<template>
  <div v-if="visible" class="jumpscare-overlay">
    <img :src="currentImage" class="jumpscare-image" draggable="false" />
  </div>
</template>

<script>
import DaysImg from '@/assets/jumpscare/7Days.jpg';
import DaysSound from '@/assets/jumpscare/7Days.mp3';
import AnimeImg from '@/assets/jumpscare/anime-ahh.png';
import AnimeSound from '@/assets/jumpscare/anime-ahh.mp3';
import BlazeImg from '@/assets/jumpscare/Blaze.webp';
import BlazeSound from '@/assets/jumpscare/Blaze.mp3';
import caveImg from '@/assets/jumpscare/cave.webp';
import caveSound from '@/assets/jumpscare/cave.mp3';
import dunImg from '@/assets/jumpscare/dundundun.jpg';
import dunSound from '@/assets/jumpscare/dundundun.mp3';
import genjiImg from '@/assets/jumpscare/genji.jpg';
import genjiSound from '@/assets/jumpscare/genji.mp3';
import herobrine1Img from '@/assets/jumpscare/herobrine1.webp';
import herobrine1Sound from '@/assets/jumpscare/herobrine1.mp3';
import herobrine2Img from '@/assets/jumpscare/herobrine2.jpg';
import herobrine2Sound from '@/assets/jumpscare/herobrine2.mp3';
import LudwigPizzaImg from '@/assets/jumpscare/LudwigPizza.png';
import LudwigPizzaSound from '@/assets/jumpscare/LudwigPizza.mp3';
import minecraftZombie2Img from '@/assets/jumpscare/minecraftZombie2.png';
import minecraftZombie2Sound from '@/assets/jumpscare/minecraftZombie2.mp3';

export default {
  name: 'JumpScare',
  emits: ['jumpscared'],
  props: {
    requiredMs: { type: Number, default: 12000 },
    showMs: { type: Number, default: 5000 },
    pollMs: { type: Number, default: 250 }
  },
  data() {
    const pool = [
      { image: DaysImg, sound: DaysSound },
      { image: AnimeImg, sound: AnimeSound },
      { image: BlazeImg, sound: BlazeSound },
      { image: caveImg, sound: caveSound },
      { image: dunImg, sound: dunSound },
      { image: genjiImg, sound: genjiSound },
      { image: herobrine1Img, sound: herobrine1Sound },
      { image: herobrine2Img, sound: herobrine2Sound },
      { image: LudwigPizzaImg, sound: LudwigPizzaSound },
      { image: minecraftZombie2Img, sound: minecraftZombie2Sound }
    ];
    return {
      pool,
      visible: false,
      accMs: 0,
      intervalId: null,
      currentImage: pool[0].image || '',
      currentAudio: null
    };
  },
  mounted() {
    // start polling: only count while tab visible
    this.intervalId = setInterval(() => {
      if (document.visibilityState === 'visible') this.accMs += this.pollMs;
      else this.accMs = 0;

      if (!this.visible && this.accMs >= this.requiredMs) this._trigger();
    }, this.pollMs);
  },
  beforeUnmount() {
    if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null; }
    this._stopAudio();
  },
  methods: {
    _pickRandom() {
      if (!Array.isArray(this.pool) || this.pool.length === 0) return { image: '', sound: '' };
      return this.pool[Math.floor(Math.random() * this.pool.length)];
    },
    _stopAudio() {
      if (this.currentAudio) {
        try { this.currentAudio.pause(); this.currentAudio.currentTime = 0; } catch (e) { console.error(e); }
        this.currentAudio = null;
      }
    },
    async _trigger() {
      const chosen = this._pickRandom();
      this.currentImage = chosen.image || '';
      this._stopAudio();
      if (chosen.sound) {
        try { this.currentAudio = new Audio(chosen.sound); } catch (e) { this.currentAudio = null; }
      } else this.currentAudio = null;

      this.visible = true;
      if (this.currentAudio) {
        try { this.currentAudio.currentTime = 0; await this.currentAudio.play(); } catch (e) { console.error(e);  }
      }
      setTimeout(this.hide, this.showMs);
    },
    hide() {
      this._stopAudio();
      this.visible = false;
      this.accMs = 0;
      this.$emit('done');
    }
  }
};
</script>

<style scoped>
.jumpscare-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

/* quick jitter + slow pulse to simulate "anschreien" */
.jumpscare-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  pointer-events: none;

  /* two animations: small fast shake and a slower pulse */
  animation: scream-shake 0.08s ease-in-out infinite alternate,
             scream-pulse 0.6s ease-in-out infinite;
  transform-origin: center center;
}

/* tiny horizontal/rotational shake */
@keyframes scream-shake {
  0%   { transform: translateX(-2px) rotate(-2deg) scale(1); }
  25%  { transform: translateX(2px)  rotate(2deg)  scale(1.02); }
  50%  { transform: translateX(-3px) rotate(-3deg) scale(1); }
  75%  { transform: translateX(3px)  rotate(3deg)  scale(1.02); }
  100% { transform: translateX(-2px) rotate(-2deg) scale(1); }
}

/* subtle scale pulse to add intensity */
@keyframes scream-pulse {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.03); }
  100% { transform: scale(1); }
}
</style>